<div
  class="row gy-2 tracking-cat-select"
  [ngClass]="{ 'gx-2': component === 'splitTransaction', 'row-cols-1': categoryOptions().length === 1 }">
  @for (category of categoryOptions(); track category.id) {
    <div class="col-12 col-sm">
      <ng-select
        [class]="{ 'ng-select-sm': component === 'splitTransaction' }"
        id="trackingCategory_{{ category.id }}"
        [items]="category.options"
        [disabled]="disabled()"
        bindLabel="name"
        bindValue="id"
        [searchable]="true"
        [clearable]="true"
        notFoundText="No options found"
        [(ngModel)]="selectedValues[category.id]"
        (ngModelChange)="onSelectionChange()"
        placeholder="Select {{ category.name }}">
      </ng-select>
    </div>
  }
</div>
